import { Controller } from "@hotwired/stimulus"
import {
  effectiveThreshold as resolveThreshold,
  effectiveDelay as resolveDelay,
  thresholdDescription as describeThreshold,
  delayDescription as describeDelay,
  combinedDescription as describeCombined,
} from "../../lib/capacity_notifier"
import { reactor } from "../../lib/reactor"

export default class extends Controller {
  static values = {
    threshold: String,
    delay: String,
    thresholdPlaceholder: Number,
    delayPlaceholder: Number,
  }

  connect() {
    reactor(this)
  }

  effectiveThreshold() {
    return resolveThreshold(this.thresholdValue, this.thresholdPlaceholderValue)
  }

  effectiveDelay() {
    return resolveDelay(this.delayValue, this.delayPlaceholderValue)
  }

  thresholdDescription() {
    return describeThreshold(this.effectiveThreshold())
  }

  delayDescription() {
    return describeDelay(this.effectiveDelay())
  }

  description() {
    return describeCombined(this.effectiveThreshold(), this.effectiveDelay())
  }
}
